import { formatRelative } from '../accounts/accountsStaleLabels'

function names(members: readonly string[]): string {
  if (members.length <= 1) return members.join('')
  return `${members.slice(0, -1).join(', ')} & ${members[members.length - 1]}`
}

/**
 * R2's line: "Sushil & Priya · 4 accounts · synced 4 min ago". Published to the
 * chrome's top bar through `usePageMeta` — the breadcrumb already holds the
 * page's one `<h1>`, so the canvas carries no second title.
 *
 * `syncedAt` is the OLDEST counted sync (a total is only as current as its
 * stalest input, D20). `null` (every account manual) drops the clause; no
 * household drops the names.
 */
export function overviewSubtitle(input: {
  members: readonly string[]
  accountCount: number
  syncedAt: Date | null
}): string {
  const parts: string[] = []
  if (input.members.length > 0) parts.push(names(input.members))
  parts.push(`${input.accountCount} ${input.accountCount === 1 ? 'account' : 'accounts'}`)
  if (input.syncedAt !== null) parts.push(`synced ${formatRelative(input.syncedAt)}`)
  return parts.join(' · ')
}
